const animationKeyFiguresCounter = () => {
	const numbers = document.querySelectorAll('.key-figures > div');

	if (numbers.length) {
		for (let i = 0; i < numbers.length; i++) {
			let counter = { var: 0 },
				element = numbers[i],
				number = element.querySelector('.key-number'),
				legend = element.querySelector('.key-legend'),
				data = number.dataset.number.split(' ').join(''),
				delay = i * 0.5;

			const updateHandler = () => {
				number.innerHTML = counter.var.toLocaleString();
			};

			const tl = gsap.timeline({defaults: {
				duration: 1.5,
				ease: 'ease.none',
			}})
			
			tl.to(counter, {
				var: data,
				roundProps: 'var',
				onUpdate: updateHandler,
				delay: delay,
			});

			if (legend) {
				tl.from(legend, {
					duration: 0.5,
					y: +40,
					autoAlpha: 0,
					ease: 'power2.out'
				}, '>-0.5')
			}


			ScrollTrigger.create({
				trigger: document.querySelector('.key-figures'),
				start: `top bottom-=100`, // the default values
				//markers: true,
                animation: tl,
				once: true
			});
		}
	}
};

export default animationKeyFiguresCounter;
